import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { _ } from '_locales';

import { colors } from '_styles';
import { WaitScreen } from '_components';

import { connect } from 'react-redux';
import { confirmHandler } from '../../utils';
import { DownloadAppBanner } from '../../../../components';

/**
 * import style's elements
 */
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Container = styled.div`
  padding: 45px 35px;
  background-color: #fff;
  box-sizing: border-box;
`;

const H3 = styled.h3`
  font-size: 20px !important;
  font-weight: 500 !important;
   
  text-align: center;
`;

const H4 = styled.h4`
  font-size: 16px !important;
  font-weight: normal !important;
   
`;

const Button = styled.button`
  position: relative;
  font-size: 14px !important;
   
  padding: 20px 0;
  background-color: ${({ disabled }) => ((disabled) ? colors.GREY : colors.RC_ACTION)};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
`;

const BodyContainer = styled.div`
    min-height: 120.5px;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 500px) {
      width: 100%;
      display: block;
    }

    ${(parentWidth < 501) && css`
      width: 100%;
      display: block;
    `};
`;

const ContentBox = styled.div`
    padding: 0 26px;
    box-sizing: border-box;

    &:first-child {
      margin-left: 0;
    }

    @media screen and (max-width: 500px) {
      margin-left: 0px;
    }

    ${(parentWidth < 501) && css`
      margin-left: 0px;
    `};
`;

const Ul = styled.ul`
    margin-top: 12px;
    list-style-type: none !important;
    padding: 0;
`;

const Li = styled.li`
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
  list-style-type: none;
  width: max-content;
  margin-bottom: 15px;
`;

const Input = styled.input`
  transform: scale(1.5);
  accent-color: ${colors.RC_ACTION};
  margin: 0 !important;
`;

const Label = styled.label`
  display: block;
  font-size: 16px !important;
`;

const Title = styled.h2`
  color: #000;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  font-family: Roboto, sans-serif;
  margin-bottom: 20px;
`;
// End style

const ZoneSetupList = ({ zone, props, has_app_download }) => {
  const { prompts } = zone;
  const prevRoute = props.location.state;

  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(prompts.map(({ prompt_id, label }) => ({ [prompt_id]: '', label })));
  const history = useHistory();

  const isOptionSelected = values.filter((item) => !item.label).map((item) => (!(item)));

  const handleChange = ({ target }) => {
    const { value } = target;
    const [promptId, zoneId, index, label] = value.split('@');
    const newValues = [...values];
    newValues[index] = { [promptId]: `${promptId}@${zoneId}@${index}`, label };

    setValues(newValues);
  };

  const clickHandler = async () => {
    try {
      setLoading(true);
      await confirmHandler(history, 'list', values, prompts, prevRoute);
      setLoading(false);

      return undefined;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(() => {
    const proceed = async () => {
      const { name, prompt_id, zones } = prompts[0];
      const { id: zoneId } = zones[0];
      const values = [{ [prompt_id]: `${prompt_id}@${zoneId}@0`, label: name }];
      setLoading(true);
      await confirmHandler(history, 'list', values, prompts, prevRoute);
      setLoading(false);
    };

    if (prompts.length === 1 && prompts[0]?.zones?.length === 1) {
      proceed();
    }
  }, []);

  return (
    <>
      <Container>
        {prevRoute?.prevRoute === '/help' ? <Title>{_('zone.ok_let_start')}</Title> : <H3>{_('zone.please_select_your_collection_zone')}</H3>}
        <BodyContainer>
          {
            prompts.map(({ prompt_id: pId, name, zones }, i) => (
              <ContentBox>
                <H4>{name}</H4>
                <Ul>
                  {
                    zones.map(({ id: zId, label }) => (
                      <Li>
                        <Input
                          type="radio"
                          id={label}
                          name={name}
                          checked={`${pId}@${zId}@${i}` === values[i][pId]}
                          value={`${pId}@${zId}@${i}@${label}`}
                          style={{ margin: '5px 10px 16px 0px', float: 'left' }}
                          onChange={handleChange}
                        />
                        <Label htmlFor={label}>{label}</Label>
                      </Li>
                    ))
                  }
                </Ul>
              </ContentBox>
            ))
          }
        </BodyContainer>

        <Button
          disabled={isOptionSelected.length || false}
          onClick={() => clickHandler()}
          aria-label="confirm to save updates"
        >
          {_('zone.save_updates')}
        </Button>

        {
          loading && (<WaitScreen />)
        }
      </Container>
      {prevRoute?.prevRoute !== '/help' && has_app_download && (
        <div style={{ padding: '0 20px 20px 20px' }}>
          <DownloadAppBanner />
        </div>
      )}
    </>

  );
};

export default connect(
  (state) => ({
    has_app_download: state?.config?.webappConfig?.has_app_download
  }),
  null
)(ZoneSetupList);
